import { createContext, useContext, useState, useCallback } from "react";

const dict = {
  fr: {
    "nav.works": "Œuvres",
    "nav.presentation": "Présentation",
    "nav.contact": "Contact",
    "nav.book": "Leftovers — Book 2026",
    "hero.kicker": "Max Dhum — Peintre · Toulouse",
    "hero.line1": "LEFTOVERS",
    "hero.line2": "Book 2026",
    "hero.sub": "Huile, acrylique, pastels — des paysages oniriques au bord de l'effondrement, peuplés d'images-vestiges.",
    "hero.cta_works": "Voir les œuvres",
    "hero.cta_about": "L'univers",
    "hero.scroll": "Défiler",
    "marquee.items": "Huile sur toile — Acrylique — Pastels — Aérosol — Posca — Paysages oniriques — Toulouse — Leftovers 2026 — ",
    "home.featured_kicker": "Sélection",
    "home.featured_title": "Œuvres choisies",
    "home.view_all": "Toute la galerie",
    "home.quote_kicker": "Carnet de l'artiste",
    "home.pillars_kicker": "Trois territoires",
    "home.pillars_cta": "Lire la présentation",
    "home.acquire_kicker": "Acquérir une œuvre",
    "home.acquire_title": "Un modèle d'achat simple, directement avec l'artiste",
    "home.acquire_text": "Chaque œuvre est une pièce unique, vendue avec certificat d'authenticité. Une demande, une réponse sous 24 h, un échange direct avec l'atelier.",
    "works.title": "Galerie",
    "works.count": "œuvres",
    "works.all": "Tout",
    "works.grid": "Index",
    "works.view": "Immersion",
    "works.available": "Disponible",
    "works.private": "Collection privée",
    "works.sold": "Vendue",
    "works.details": "Fiche œuvre",
    "works.hint": "Survolez pour zoomer · ← → pour naviguer",
    "detail.year": "Année",
    "detail.technique": "Technique",
    "detail.support": "Support",
    "detail.dimensions": "Dimensions",
    "detail.series": "Série",
    "detail.price": "Prix",
    "detail.status": "Disponibilité",
    "detail.acquire": "Acquérir cette œuvre",
    "detail.sold_note": "Cette œuvre a rejoint une collection privée.",
    "detail.prev": "Œuvre précédente",
    "detail.next": "Œuvre suivante",
    "detail.back": "Retour à la galerie",
    "detail.certificate": "Pièce unique · Certificat d'authenticité signé inclus",
    "acquire.title": "Demande d'acquisition",
    "acquire.step1_t": "1. Votre demande",
    "acquire.step1": "Envoyez ce formulaire — il part directement à l'atelier.",
    "acquire.step2_t": "2. Réponse sous 24 h",
    "acquire.step2": "L'artiste vous répond personnellement : disponibilité, photos, cadre, envoi.",
    "acquire.step3_t": "3. Acquisition",
    "acquire.step3": "Paiement sécurisé convenu ensemble, certificat signé, livraison suivie ou remise à l'atelier de Toulouse.",
    "acquire.name": "Votre nom",
    "acquire.email": "Votre e-mail",
    "acquire.message": "Message (optionnel)",
    "acquire.send": "Envoyer la demande",
    "acquire.sending": "Envoi…",
    "acquire.sent_title": "Demande envoyée",
    "acquire.sent": "Merci — l'atelier revient vers vous sous 24 h. Vous pouvez aussi écrire directement :",
    "acquire.close": "Fermer",
    "acquire.direct": "Ou par e-mail direct",
    "contact.kicker": "Contact",
    "contact.title": "Écrivons-nous",
    "contact.sub": "Acquisitions, expositions, commandes ou simple curiosité — deux canaux, rien de plus.",
    "contact.email_label": "E-mail",
    "contact.copy": "Copier",
    "contact.copied": "Copié",
    "contact.ig_label": "Instagram",
    "contact.ig_cta": "Suivre l'atelier au quotidien",
    "pres.kicker": "Présentation",
    "pres.title": "Max Dhum",
    "pres.bio_kicker": "Biographie",
    "pres.pillars_kicker": "L'univers",
    "pres.expo_kicker": "Parcours",
    "pres.expo_title": "Expositions",
    "pres.atelier": "L'atelier, Toulouse",
    "footer.rights": "Tous droits réservés",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.book": "Leftovers — Book 2026",
    "admin.login_title": "Espace atelier",
    "admin.login_sub": "Gestion des œuvres et des textes",
    "admin.password": "Mot de passe",
    "admin.signin": "Se connecter",
    "admin.logout": "Déconnexion",
    "admin.works": "Œuvres",
    "admin.texts": "Textes",
    "admin.enquiries": "Demandes",
    "admin.add": "Nouvelle œuvre",
    "admin.edit": "Modifier",
    "admin.delete": "Supprimer",
    "admin.save": "Enregistrer",
    "admin.cancel": "Annuler",
    "admin.saved": "Enregistré",
    "admin.none": "Aucune demande pour le moment.",
    "error.load": "Chargement impossible.",
  },
  en: {
    "nav.works": "Works",
    "nav.presentation": "About",
    "nav.contact": "Contact",
    "nav.book": "Leftovers — Book 2026",
    "hero.kicker": "Max Dhum — Painter · Toulouse",
    "hero.line1": "LEFTOVERS",
    "hero.line2": "Book 2026",
    "hero.sub": "Oil, acrylic, pastels — oneiric landscapes on the verge of collapse, populated by image-remnants.",
    "hero.cta_works": "View the works",
    "hero.cta_about": "The universe",
    "hero.scroll": "Scroll",
    "marquee.items": "Oil on canvas — Acrylic — Pastels — Spray paint — Posca — Oneiric landscapes — Toulouse — Leftovers 2026 — ",
    "home.featured_kicker": "Selection",
    "home.featured_title": "Chosen works",
    "home.view_all": "Full gallery",
    "home.quote_kicker": "From the artist's notebook",
    "home.pillars_kicker": "Three territories",
    "home.pillars_cta": "Read the presentation",
    "home.acquire_kicker": "Acquire a work",
    "home.acquire_title": "A simple way to buy, directly from the artist",
    "home.acquire_text": "Each work is a unique piece, sold with a signed certificate of authenticity. One request, an answer within 24 hours, a direct conversation with the studio.",
    "works.title": "Gallery",
    "works.count": "works",
    "works.all": "All",
    "works.grid": "Index",
    "works.view": "Immersive",
    "works.available": "Available",
    "works.private": "Private collection",
    "works.sold": "Sold",
    "works.details": "Artwork file",
    "works.hint": "Hover to zoom · ← → to navigate",
    "detail.year": "Year",
    "detail.technique": "Technique",
    "detail.support": "Support",
    "detail.dimensions": "Dimensions",
    "detail.series": "Series",
    "detail.price": "Price",
    "detail.status": "Availability",
    "detail.acquire": "Acquire this work",
    "detail.sold_note": "This work has joined a private collection.",
    "detail.prev": "Previous work",
    "detail.next": "Next work",
    "detail.back": "Back to gallery",
    "detail.certificate": "Unique piece · Signed certificate of authenticity included",
    "acquire.title": "Acquisition request",
    "acquire.step1_t": "1. Your request",
    "acquire.step1": "Send this form — it goes straight to the studio.",
    "acquire.step2_t": "2. Answer within 24 h",
    "acquire.step2": "The artist replies personally: availability, photos, framing, shipping.",
    "acquire.step3_t": "3. Acquisition",
    "acquire.step3": "Secure payment agreed together, signed certificate, tracked delivery or pick-up at the Toulouse studio.",
    "acquire.name": "Your name",
    "acquire.email": "Your e-mail",
    "acquire.message": "Message (optional)",
    "acquire.send": "Send the request",
    "acquire.sending": "Sending…",
    "acquire.sent_title": "Request sent",
    "acquire.sent": "Thank you — the studio will get back to you within 24 hours. You can also write directly:",
    "acquire.close": "Close",
    "acquire.direct": "Or by direct e-mail",
    "contact.kicker": "Contact",
    "contact.title": "Let's write",
    "contact.sub": "Acquisitions, exhibitions, commissions or simple curiosity — two channels, nothing more.",
    "contact.email_label": "E-mail",
    "contact.copy": "Copy",
    "contact.copied": "Copied",
    "contact.ig_label": "Instagram",
    "contact.ig_cta": "Follow the studio day to day",
    "pres.kicker": "Presentation",
    "pres.title": "Max Dhum",
    "pres.bio_kicker": "Biography",
    "pres.pillars_kicker": "The universe",
    "pres.expo_kicker": "Journey",
    "pres.expo_title": "Exhibitions",
    "pres.atelier": "The studio, Toulouse",
    "footer.rights": "All rights reserved",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.book": "Leftovers — Book 2026",
    "admin.login_title": "Studio area",
    "admin.login_sub": "Manage works and texts",
    "admin.password": "Password",
    "admin.signin": "Sign in",
    "admin.logout": "Log out",
    "admin.works": "Works",
    "admin.texts": "Texts",
    "admin.enquiries": "Enquiries",
    "admin.add": "New artwork",
    "admin.edit": "Edit",
    "admin.delete": "Delete",
    "admin.save": "Save",
    "admin.cancel": "Cancel",
    "admin.saved": "Saved",
    "admin.none": "No enquiry yet.",
    "error.load": "Could not load.",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("md-lang") || "fr");
  const setLang = useCallback((l) => {
    localStorage.setItem("md-lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((k) => dict[lang][k] ?? k, [lang]);
  const loc = useCallback((obj, field) => obj?.[`${field}_${lang}`] ?? obj?.[`${field}_fr`] ?? "", [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t, loc }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);

export const statusKey = (s) => (s === "available" ? "works.available" : s === "sold" ? "works.sold" : "works.private");

export const fmtPrice = (n, lang) =>
  new Intl.NumberFormat(lang === "fr" ? "fr-FR" : "en-IE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);
